export * from './components/static-viewer';
